
import Vue from 'vue'
import { HeaderNav } from './Nav'
import LoginArea from './LoginArea.vue'
import LoginHelper from './LoginHelper'
import { message,Modal } from 'ant-design-vue'
import { mapGetters, mapState } from 'vuex'

const open = (url: string): void => {
  window.open(url, '_blank')
}

export default Vue.extend({
  name: 'AheduHeader',
  components: {
    LoginArea,
    ...mapState('user', {
      userId: (state:any) => state.user.userId
    }),
    ...mapGetters('user', ['isLogin'])
  },
  props: {
    activeName: String,
    system: String,
    title: {
      type: String,
      default: '皖教云',
    },
  },
  data() {
    return {
      headerArray: [] as HeaderNav[],
      hoverIndex: 0,
      viewIndex: 0,
      hoverChildIndex: 0,
    }
  },
  mounted() {
    this.headerArray = window.commonNav
  },
  methods: {
    handleClick(item: HeaderNav) {
      this.hoverChildIndex = 0

      if (item.needLogin) {
        this.needLogin(item.href,item.name)
       } else {
        open(item.href)
      }
    },
    /**
     * 如果需要登录，就判断有没有登录，没有登录要提示请登录
     */
    needLogin(href: string,name :string) {
      console.log(href) 
     
      if (LoginHelper.isLogin) {
        if(name=="开放平台管理后台"){
          Modal.info({
            class:"nav-info-box",
            title:"提示",
            content:"皖教云开放平台是一个为第三方开发者提供应用接入服务的平台，提供公共服务能力，让开发者可以自主开发应用。如需使用该服务，请先注册开发者账号。",
            okText:"我知道了",
            onOk() {
              window.open('http://open.ahjygl.gov.cn/openplatform/#/home')
            },
          })
      }else{
        open(href)
      } 
       
      } else { 
        message.warning('请登录')
      }
    },
  },
})
